import { createStructuredSelector } from 'reselect'

import { selectStencilsDataForCart } from 'product_tabs/tab_smt_stencils/selector/selectors';
import { selectBomDataForCart } from 'product_tabs/tab_parts/selector/selectors';
import { selectAccessoryCartInfo } from 'product_tabs/tab_accessories/selectors/selectors';
import { selectAssemblyDataForCart } from 'product_tabs/tab_assembly/selector/selector';

export const selectDataForCart = createStructuredSelector({
  stencils: selectStencilsDataForCart,
  parts: selectBomDataForCart,
  accessories: selectAccessoryCartInfo,
  assembly: selectAssemblyDataForCart,
});